import { StatusModel } from "./topicModels";

const LIST_STATUS: any = [
    {
        label: 'Not Started',
        value: '0'
    },
    {
        label: 'In Progress',
        value: '1'
    },
    {
        label: 'Awaiting Approval',
        value: '2'
    },
    {
        label: 'Draft',
        value: '3'
    },
    {
        label: 'Approved',
        value: '4'
    }
]

export default LIST_STATUS;


export const LIST_STATUS_REVIEW = {
    NOT_STARTED: 'NOT_STARTED',
    IN_PROGRESS: 'IN_PROGRESS',
    AWAITING_APPROVAL: 'AWAITING_APPROVAL',
    DRAFT: 'DRAFT',
    APPROVED: 'APPROVED',
}


export const LIST_STATUS_REVIEW_FILTER: any = {
    NOT_STARTED: 'Not Started',
    IN_PROGRESS: 'In Progress',
    AWAITING_APPROVAL: 'Awaiting Approval',
    DRAFT: 'Draft',
    APPROVED: 'Approved',
}

export const STATUS_FEEDBACK: StatusModel[] = [
    {
        value: 0,
        label: "Submitted",
        color: '#000'
    },
    {
        value: 1,
        label: "Resolved",
        color: '#69be28'
    },
    {
        value: 2,
        label: "Rejected",
        color: '#FF0000'
    }
]